import React, { Fragment } from 'react';
import uuid from 'uuid';

import { ContainerMessage, Activity } from './style';

import { UserChar } from '../utilities/styledComponents/UserChar';

const Message = ({ content }) => (
	<ContainerMessage>
		<UserChar className="mr-2">
			<span>{content.user_name.charAt(0)}</span>
		</UserChar>

		<Activity>
			<header className="p-0">
				<strong className="name">{content.user_name}</strong>
				<span className="date">{`Em: ${content.date}.`}</span>
			</header>

			{
				content.action_description ? (
					<main>
						{
							(typeof content.action_description !== 'string' && content.action_description.length > 1) ? (
								<Fragment>
									<p className="m-0">{`${content.action_title}:`}</p>
									<ul className="p-0">
										{content.action_description.map(description => (
											<li key={uuid.v4()}>- {description}.</li>
										))}
									</ul>
								</Fragment>
							) : (
								<p>{`${content.action_title}`} <i className="fas fa-arrow-right mr-1 ml-1" /> {`${content.action_description}.`}</p>
								)
						}
					</main>
				) : (
					<main>
						<p className="m-0">{content.text}</p>
					</main>
					)
			}
		</Activity>
	</ContainerMessage>
);

export default Message;
